const TEST_ID_ATTRIBUTE = 'test-id';

type SlotResolver = (ownerState: never) => Record<string, unknown>;

const mergeTestIdIntoSlot = (slot: unknown, testId: string) => {
  if (typeof slot === 'function') {
    const resolveSlot = slot as SlotResolver;

    return (ownerState: never) => ({ ...resolveSlot(ownerState), [TEST_ID_ATTRIBUTE]: testId });
  }

  return { ...(slot as Record<string, unknown> | undefined), [TEST_ID_ATTRIBUTE]: testId };
};

export const withTestId = <TSlotProps extends object | undefined>(
  slotProps: TSlotProps,
  slot: keyof NonNullable<TSlotProps> & string,
  testId: string | undefined,
): TSlotProps => {
  if (!testId) {
    return slotProps;
  }

  const slots = (slotProps ?? {}) as Record<string, unknown>;

  return { ...slots, [slot]: mergeTestIdIntoSlot(slots[slot], testId) } as TSlotProps;
};
